/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
define(['jquery', 'underscore', 'assets/js/modules/View'], function($, _, View) {
    var LABEL_CLASS_ACTIVE = 'active';

    return View.extend({
        className: 'btn',

        tagName: 'label',

        events: {
            click: 'onClick'
        },

        /**
         * @param {Event} e
         */
        onClick: function(e) {
            if (!this.model.get('disabled')) {
                this.model.trigger('selected', this.model);
            }
        },

        /**
         * @inheritdoc
         */
        initialize: function() {
            this.template = this.getTemplate();
        },

        /**
         * @return {RadioView}
         */
        render: function() {
            this.$el.html(
                this.template({
                    name: this.model.get('name'),
                    value: this.model.get('value'),
                    title: this.model.get('title'),
                    active: this.model.get('active'),
                    disabled: this.model.get('disabled')
                })
            );

            if (this.model.get('active')) {
                this.$el.addClass(LABEL_CLASS_ACTIVE);
            }

            if (this.model.get('disabled')) {
                this.$el.attr('disabled', 'disabled');
            }

            return this;
        },

        /**
         * @return string
         */
        getTemplate: function() {
            return _.template(
                '<%- title %><input type="radio" name="<%- name %>" value="<%- value %>" <% if (active) {%>checked<% } %> <% if (disabled) {%>disabled="disabled"<% } %>>'
            );
        }
    });
});
